import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  EditCustomerSupplierPayloadType,
  GetSingleCustomerSupplierListPayloadType,
} from "../../../commonTypes/clientSettingsTypes";
import CustomerSupplierForm from "../../../components/ClientSettings/CustomerSupplierManager/CustomerSupplierForm";
import {
  CommonHeader,
  Loader,
  ErrorSuccessModal,
} from "../../../components/commons";
import { resetSession } from "../../../redux/auth";
import {
  editCustomerSupplierAction,
  getSingleCustomerSupplierAction,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetCustomerSupplierGroupingList,
  resetCustomerSupplierGroupingTotalCount,
  resetCustomerSupplierList,
  resetSingleCustomerSupplier,
} from "../../../redux/clientSettings";
import { CustomerSupplierListType } from "../../../redux/clientSettings/clientSettingTypes";
import { RootState } from "../../../redux/rootReducers";
import { useLocation, useParams } from "react-router-dom";

type AppProps = {
  token: string | null;
  history: any;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  singleCustomerSupplier: CustomerSupplierListType;
  dispatchResetClientSettingsError: () => void;
  dispatchResetClientSettingsSuccessAction: () => void;
  dispatchResetCustomerSupplierListAction: () => void;
  dispatchEditCustomerSupplierAction: (
    data: EditCustomerSupplierPayloadType
  ) => void;
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => void;
  dispatchResetSession: () => void;
  dispatchResetCustomerSupplierGroupingList: () => void;
  dispatchResetCustomerSupplierGroupingListTotal: () => void;
};

const EditCustomerSupplierAddress = ({
  token,
  history,
  fetching,
  success,
  error,
  statusCode,
  dispatchEditCustomerSupplierAction,
  dispatchResetClientSettingsError,
  dispatchResetClientSettingsSuccessAction,
  dispatchResetSession,
  dispatchGetSingleCustomerSupplierAction,
  singleCustomerSupplier,
  dispatchResetCustomerSupplierListAction,
  dispatchResetCustomerSupplierGroupingList,
  dispatchResetCustomerSupplierGroupingListTotal,
}: AppProps) => {
  const searchData = history?.location?.state?.searchData;
  const search = useLocation().search;
  const clientCodeFromParams = new URLSearchParams(search).get("client_code");
  const companyNameFromParams = new URLSearchParams(search).get("company_name");
  const ledgerId: any = useParams();
  const company_name = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : companyNameFromParams;
  const client_code = history?.location?.state?.client_code
    ? history?.location?.state?.client_code
    : clientCodeFromParams;
  var data = singleCustomerSupplier
    ? singleCustomerSupplier
    : history?.location?.state?.data;
  const isEdit = singleCustomerSupplier
    ? true
    : history?.location?.state?.isEdit;
  const redirectedLedgerId = ledgerId.address_id;
  const persistFilterCustomerSupplier = history?.location?.state?.filterData;

  const [userType, setUserType] = useState<string>("");
  useEffect(() => {
    dispatchResetClientSettingsError();
    dispatchResetClientSettingsSuccessAction();
    dispatchResetCustomerSupplierGroupingList();
    dispatchResetCustomerSupplierGroupingListTotal();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (redirectedLedgerId && clientCodeFromParams) {
      let finalData = {
        token,
        client_code,
        customerSupplierId: redirectedLedgerId.toString(),
      };
      dispatchGetSingleCustomerSupplierAction(finalData);
    }
    //eslint-disable-next-line
  }, [redirectedLedgerId]);

  const handleSubmitData = (data: EditCustomerSupplierPayloadType) => {
    setUserType(data?.type);
    if (client_code && token) {
      let finalData = {
        ...data,
        token,
        client_code,
      };
      dispatchEditCustomerSupplierAction(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`${
            userType === "supplier" ? "Supplier" : "Customer"
          } Updated Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetClientSettingsSuccessAction();
            dispatchResetCustomerSupplierListAction();
            clientCodeFromParams ? handleGoBack("urlParams") : handleGoBack();
          }}
          statusCode={statusCode}
        />
      );
    }

    return false;
  };

  const handleGoBack = (params?: string) => {
    const clientCodeParams = clientCodeFromParams;

    history?.push({
      pathname: `/client-settings/customers-suppliers/${
        params ? clientCodeParams : client_code
      }`,
      state: {
        client_code,
        company_name,
        filterData: { ...persistFilterCustomerSupplier },
        searchData,
      },
    });

    localStorage.removeItem("ledger_id");
    localStorage.removeItem("client_code");
    localStorage.removeItem("company_name");
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonHeader
            title="Edit Customer/Supplier"
            company_name={company_name}
            client_code={client_code}
          />
        </div>
      </div>
      <CustomerSupplierForm
        history={history}
        toggleModal={handleGoBack}
        handleSubmitData={handleSubmitData}
        client_code={client_code}
        company_name={company_name}
        isEdit={isEdit}
        customerSupplierData={data}
        redirectedLedgerId={redirectedLedgerId}
      />
      {handleErrorModal()}
      {fetching && <Loader />}
    </>
  );
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.clientSettings.fetching,
  success: state.clientSettings.success,
  error: state.clientSettings.error,
  statusCode: state.clientSettings.statusCode,
  singleCustomerSupplier: state.clientSettings.singleCustomerSupplier,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchResetClientSettingsSuccessAction: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchEditCustomerSupplierAction: (data: EditCustomerSupplierPayloadType) =>
    dispatch(editCustomerSupplierAction(data)),
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => dispatch(getSingleCustomerSupplierAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetCustomerSupplierListAction: () =>
    dispatch(resetCustomerSupplierList()),
  dispatchResetCustomerSupplierGroupingList: () =>
    dispatch(resetCustomerSupplierGroupingList()),
  dispatchResetCustomerSupplierGroupingListTotal: () =>
    dispatch(resetCustomerSupplierGroupingTotalCount()),
});

export default connect(
  mapStateTopProps,
  mapDispatchToProps
)(EditCustomerSupplierAddress);
